import React from 'react';
import PropTypes from 'prop-types';

import DogSearchingSvg from 'dpl/common/components/DogSearching';

export default function BreederProfileHelpBox({ breedNamePlural }) {
  return (
    <div className="BreederProfileHelpBox w-100 flex-l">
      <div className="mb4 mb0-lg mr6-lg d-none d-lg-block">
        <div className="stone-700 w6">
          <DogSearchingSvg />
        </div>
      </div>
      <div>
        <p className="mb3 primary f4 fw-medium">
          Adopting from a Shelter or Rescue
        </p>
        <p className="BreederProfileHelpBox__text mb4 black-90">
          Can&apos;t find the right pup for you? We encourage you to explore our
          Good Shelters and Rescues. Unlike our Good Breeders, irresponsible
          owners and unethical practices have led to the abandonment of many{' '}
          {breedNamePlural}.
        </p>
      </div>
    </div>
  );
}

BreederProfileHelpBox.propTypes = {
  breedNamePlural: PropTypes.string.isRequired
};
